module.exports = __webpack_public_path__ + "static/11-9028bcd808edfc85765be1ddd35f0263.jpg";